import { render } from "./airqualitynpRecent.vue?vue&type=template&id=6626156a"
import script from "./airqualitynpRecent.vue?vue&type=script&lang=js"
export * from "./airqualitynpRecent.vue?vue&type=script&lang=js"

import "./airqualitynpRecent.vue?vue&type=style&index=0&id=6626156a&lang=scss"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__